import { render, staticRenderFns } from "./OrganisationTypePicker.vue?vue&type=template&id=5cf46452"
import script from "./OrganisationTypePicker.vue?vue&type=script&lang=js"
export * from "./OrganisationTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports